export default {
  HOME_MUTATIONS(state, { key, value }) {
    state[key] = value;
  },
};
